export var AGORAPP_URL = 'https://agorapp.dev';
//# sourceMappingURL=config.js.map